if (!customElements.get("m-product-inventory")) {
    class t extends HTMLElement {
        constructor() {
            super(), this.selectors = {
                inventoryQuantity: ".m-product-inventory__quantity",
                inventoryStatus: ".m-product-inventory__status",
                inventoryMessage: ".m-product-inventory__message",
                indicatorBar: ".m-product-inventory__indicator-bar"
            }, this.domNodes = queryDomNodes(this.selectors, this)
        }
        connectedCallback() {
            this.productId = this.dataset.productId, this.inventoryVisibility = this.dataset.inventoryVisibility, this.hideStockBackordered = "true" === this.dataset.hideStockBackordered, this.handleVariantChange(), this.updateInventoryStatus(parseInt(this.dataset.inventoryQuantity), "true" === this.dataset.variantAvailable, this.dataset.inventoryPolicy)
        }
        handleVariantChange() {
            window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (t => {
                if (t) {
                    const e = JSON.parse(this.querySelector('[type="application/json"]').textContent).filter((e => e.id === t.id))[0];
                    this.updateInventoryStatus(parseInt(e.inventory_quantity), e.available, e.inventory_policy)
                } else this.updateInventoryStatus(0, !1)
            }))
        }
        updateInventoryStatus(t, e, s) {
          if (t <= this.dataset.inventoryThreshold) {
            this.style.display = 'block';
          } else {
            this.style.display = 'none';
          }
            let i, o = !1;
            i = t <= 0 ? "continue" === s ? "backordered" : e ? "instock" : "outofstock" : t <= this.dataset.inventoryThreshold ? "low" : "normal", this.setAttribute("data-status", i), "always" == this.inventoryVisibility ? (o = !0, "backordered" == i && this.hideStockBackordered && (o = !1)) : "low" == i && (o = !0), o ? (this.classList.remove("m:hidden"), this.domNodes.inventoryMessage.innerHTML = this.getInventoryText()[i].message, this.getInventoryText()[i].show_count ? (this.domNodes.inventoryQuantity.classList.remove("m:hidden"), this.domNodes.inventoryQuantity.innerHTML = t) : (this.domNodes.inventoryQuantity.innerHTML = "", this.domNodes.inventoryQuantity.classList.add("m:hidden")), this.getInventoryText()[i].text ? (this.domNodes.inventoryStatus.classList.remove("m:hidden"), this.domNodes.inventoryStatus.innerHTML = this.getInventoryText()[i].text) : (this.domNodes.inventoryStatus.innerHTML = "", this.domNodes.inventoryStatus.classList.add("m:hidden")), this.handleIndicatorBar(i, t)) : this.classList.add("m:hidden")
        }
        handleIndicatorBar(t, e) {
            if (this.domNodes.indicatorBar) {
                const s = this.dataset.total;
                let i;
                i = "backordered" != t && (e >= s || "instock" == t) ? 100 : (e / s * 100).toFixed(1), this.domNodes.indicatorBar.querySelector("span").style.width = `${i}%`
            }
        }
        getInventoryText() {
            const {
                inStock: t,
                outOfStock: e,
                lowStock: s
            } = window.MinimogStrings, i = this.dataset.showInventoryCount;
            return {
                normal: {
                    text: t,
                    message: this.dataset.normalText,
                    show_count: "always" == i
                },
                instock: {
                    text: t,
                    message: this.dataset.normalText,
                    show_count: !1
                },
                low: {
                    text: s,
                    message: this.dataset.lowText,
                    show_count: "never" != i
                },
                outofstock: {
                    text: e,
                    message: this.dataset.outofstockText,
                    show_count: !1
                },
                backordered: {
                    text: "",
                    message: this.dataset.backorderedText,
                    show_count: !1
                }
            }
        }
    }
    customElements.define("m-product-inventory", t)
}